import React, { useContext } from 'react';
import propTypes from 'prop-types';
import { QuantityContext } from '../../QuantitySelector/QuantityProvider';
import { InstallationOption } from './InstallationOption';

const installationCards = window.drupalSettings.installationCards || {};

const info = {
  standardInstallation: {
    name: installationCards?.tdStandard?.name ?? 'TD Standard',
    description: installationCards?.tdStandard?.value ?? '',
    includes: installationCards?.tdStandard?.includes ?? '',
    extras: installationCards?.tdStandard?.extras ?? '',
  },
  trailerTireInstallation: {
    name: installationCards?.trailerTire?.name ?? 'Trailer Tire',
    description: installationCards?.trailerTire?.value ?? '',
    includes: installationCards?.trailerTire?.includes ?? '',
    extras: installationCards?.trailerTire?.extras ?? '',
  },
};

const InstallationOptions = ({
  pricing, isSplitFitment, standardInstallation, trailerTireInstallation, isTrailerTire,
}) => {
  const { quantities } = useContext(QuantityContext);

  let quantity = quantities.qtyFront;
  if (isSplitFitment) {
    quantity += quantities.qtyRear;
  }

  return (
    <>
      <h3 className="cmp-quote__heading">Installation & Additional Services</h3>
      <div className="cmp-quote-option__card installation-options">
        {!isTrailerTire && (
          <InstallationOption
            data={standardInstallation}
            quantity={quantity}
            pricing={pricing}
            info={info.standardInstallation}
          />
        )}
        {isTrailerTire && (
          <InstallationOption
            data={trailerTireInstallation}
            quantity={quantity}
            pricing={pricing}
            info={info.trailerTireInstallation}
          />
        )}
      </div>
    </>
  );
};

InstallationOptions.propTypes = {
  pricing: propTypes.shape({
    standardInstallation: propTypes.number,
    economyInstallation: propTypes.number,
    trailerTireInstallation: propTypes.number,
  }),
  isSplitFitment: propTypes.bool,
  standardInstallation: propTypes.shape({
    id: propTypes.number,
    productType: propTypes.string,
    sku: propTypes.string,
  }),
  economyInstallation: propTypes.shape({
    id: propTypes.number,
    productType: propTypes.string,
    sku: propTypes.string,
  }),
  trailerTireInstallation: propTypes.shape({
    id: propTypes.number,
    productType: propTypes.string,
    sku: propTypes.string,
  }),
  isTrailerTire: propTypes.bool,
};

export { InstallationOptions };
